import { RegisterForm } from "../components/features/auth/RegisterForm";

export function Register() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 py-12 px-4 sm:px-6 lg:px-8">
      <RegisterForm />
    </div>
  );
}

export default Register;
